import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
  
const Infinity = () => 
{
  return (
    <div className='bg-silver'>
      <div className='bg-white fixed top-0 right-0 left-0 z-20 '>
        <div className="flex justify-between mb-2" > 
          <div className='mt-3 ml-5'>
            <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
          </div>
          <div className='flex' >
            <div className='bg-blue1 w-[90px] h-[60px] ml-4'>  
              <a href="#"><img src="/Other_Images/imageuser.png" class="rounded-3xl p-3" alt="user"></img></a>
            </div>
          </div>
        </div>
        <div className="mb-1 md:mx-2 lg:mx-6">
          <a href='/about' target='blank'><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-lg'>About Company</button></a>
          <a href='/aboutme' target='blank'><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md lg:p-3 p-1 text-xs lg:text-lg'>About Me</button></a>
          <a href='/learningcenter' target='blank'><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md lg:p-3 p-1 text-xs lg:text-lg'>Learning Center</button></a>
        </div>
      </div>
      <div className='bg-silver pt-36'/>              
      
      <section>     
        <p className="pt-8 ml-10 text-2xl text-headings">Infinity</p>
        <div className='lg:flex justify-around pt-8 mx-4'>
          <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 lg:w-[400px] h-[80px] shadow-xl'>
            <div className='text-sm'>
              <ul className='text-sm mt-5'>
                <li className='flex mt-2'><img src="/Other_Images/excel.png" className='w-[15px] h-[15px]'/><a className="ml-4" target="_blank" href='/Excel_Files/4wYFVlkK.xls'>Team Lead</a></li>  
              </ul>   
            </div>    
          </div>
          <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 lg:w-[400px] h-[80px] shadow-xl'>
            <div className='text-sm'>
              <ul className='text-sm mt-5'>
                <li className='flex mt-2'><img src="/Other_Images/excel.png" className='w-[15px] h-[15px]'/><a className="ml-4" target="_blank" href='/Excel_Files/RmLOzeV0.xls'>Designers</a></li>  
              </ul>   
            </div>    
          </div>
        </div>
      </section>

      <section>
        <div className=" bg-darkblue mt-[75px] fixed left-[0] bottom-[0] right-[0] ">
          <div className=' text-metal lg:flex lg:justify-between lg:mx-2 lg:pl-3 mx-2 '>    
            <div className=''/>
            <div>
              <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 text-white'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Infinity;
